import {DwellReasonTypeCd} from '../';
import {EnumHelper} from './enum-helper';

export class DwellReasonTypeCdHelperEnumHelperClass extends EnumHelper {

  public constructor() {
  	super();
    for ( const obj in DwellReasonTypeCd ) {
      this._values.push(DwellReasonTypeCd[obj]);
      this._keys.push(obj);
    }
  }

  public toEnum(value: string): DwellReasonTypeCd {

    for ( const obj in DwellReasonTypeCd ) {
      if (DwellReasonTypeCd[obj] === value){
        return DwellReasonTypeCd[obj] as DwellReasonTypeCd;
      }
    }
  }
}

const DwellReasonTypeCdHelper = new DwellReasonTypeCdHelperEnumHelperClass();
export default DwellReasonTypeCdHelper;
